import Tone from 'tone';
import {setEffectParameterValues} from 'actions/index.js';
import {A_RATE} from 'constants/automation-rates.js';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Effects from 'effects/Effects.js';
import {AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';

class Panner extends Effects.Effect {

    constructor(sequencerEngine) {
        super("Panner", () => new Tone.Panner(0), sequencerEngine);
        this.panningParameter = new AudioParamValueParameter(
            'Panning', this.effectNode._panner.pan, {
                min: -1,
                log: true,
                max: 1,
                unit: '',
                defaultValue: 0,
                automationRate: A_RATE,
                noInput: true
            });
        this.registerParameter(this.panningParameter);
        this.updateInitialValues();
    }

   getJson() {
        let json = super.getJson();
        json.panning = this.panningParameter.get(true);
        json.enabled = this.enabledParameter.get(true);
        json.name = this.name;

        json = this.saveParameterToJson(json, 'panningParameter', this.panningParameter);
        return json;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);

        bulkUpdate(this.panningParameter, json.panning, bulk);
        if (json.enabled) {
            this.enable(true);
        }
        
        return {
            ... bulk,
            ... this.loadParameterFromJson(json, 'panningParameter', this.panningParameter, isCopy)
        };
        return bulk;
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new Panner(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default Panner;
